function gtmDataLayersPush(events, elementVal, section_clicked, mainHeader, subHeader, nextPage, currentPage,customerId) {
    window.dataLayer.push({
        event: events,
        click_text: elementVal,
        section_clicked: section_clicked,
        link_header: mainHeader,
        userID:customerId,
        link_sub_header: subHeader,
        nextPage: nextPage,
        currentPage: currentPage,

    });
}

$(document).on('click', '.footer-container .footer-item a:not(.footer-link)', function (e) {
    e.preventDefault();
    let elementVal = $(this).html();
    let mainHeader = $(this).closest('.content-asset ').find('.title').html();
    if (mainHeader == undefined) {
        mainHeader = 'root';
    }
    let subHeader = elementVal;
    let nextPage = $(this).attr('href');
    let currentPage = window.location.href;
    let url = $('#customerNoUrl').val();
    let customerId="";

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success(dataFromAjax) {
            if(dataFromAjax.customerId){
                customerId = dataFromAjax.customerId;
            }
            gtmDataLayersPush("Footer_Navigation", elementVal, "Footer_Navigation", mainHeader, subHeader, nextPage, currentPage,customerId);
            window.location.href = nextPage;
        }
    });
});


$(document).on('click', '.social-links a', function (e) {
    e.preventDefault();
    let textClicked = $(this).attr('aria-label');
    let nextPage = $(this).attr('href');
    let currentPage = window.location.href;
    let url = $('#customerNoUrl').val();
    let customerId="";

    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success(dataFromAjax) {
            if(dataFromAjax.customerId){
                customerId = dataFromAjax.customerId;
            }
            window.dataLayer.push({
                event: "Footer_Navigation",
                click_text: textClicked,
                section_clicked: "Footer_Navigation",
                link_header: "Social_Icons",
                userID:customerId,
                nextPage: nextPage,
                currentPage: currentPage
            });
            window.location.href = nextPage;
        }
    });
}); 
